module.exports = __webpack_public_path__ + "static/img/0011-A-01.67eb396.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0011-A-01.jpg
// module id = /VOb
// module chunks = 0